import React from 'react';
import {Select} from 'antd';
import {postSync} from '../../utils/http'
import {isEmpty} from "../../utils/StringUtils";
import {getLanguage} from "../../../source/js/common";

const commonLan = require('../../../constant/js/formItemNameLabel/'+getLanguage()+'/common');

const Option = Select.Option;

let allOptions = {};
class CommonDictSelect extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            optionsData: '',
            oriData:[],
        };
    }
    getData(){
        return this.state.oriData;
    }
    componentDidMount(){
        const typeCode = this.props.typecode;
        const optionList = allOptions[typeCode.toString()];
        //判断下拉框选项是否已存在，如果存在，直接用；
        // 如果不存在，从后台接口查询，并保存数据字典allOptions变量里（已备下次使用，减少接口调用，优化体验）
        if (optionList){
            this.handleRemove(optionList);

        } else {

            postSync('aisino/portalIndex/getDictByTypeCode', {typeCode:typeCode}).then(response => {
                //console.log("response=====CommonDictSelect====" + JSON.stringify(response));
                if(this.props.codeAppendName){
                    response.map((data) => {
                        data.name = '('+data.value+')'+data.name
                    })
                }
                if (response) {
                    this.handleRemove(response);
                    allOptions[typeCode.toString()] = response;
                }
            });
        }
    }
    handleRemove(data){
        const removeKey = this.props.remove_one;
        const removeKeys = this.props.remove_more;
        let optionList =data;
        if(removeKey){
            optionList = this.removeByKey(optionList,removeKey);
        }
        if(removeKeys){
            let removeArr = removeKeys.split(",");
            for(let i=0;i<removeArr.length;i++){
                optionList = this.removeByKey(optionList,removeArr[i]);
            }
        }
        this.setOptionsData(optionList);
    }
    componentWillUnmount() {
        this.setState = ()=>false;
    }

    removeByKey(arr, removeKey) {
        let result=[];
        if (isEmpty(arr)) {
            return result;
        }

        for(let i=0; i<arr.length; i++){
            if(arr[i].value !== removeKey){
                result.push(arr[i]);
            }
        }
        return result;
    }
    setOptionsData(optionList){
        this.state.oriData=optionList;
        let children = [];
        if(this.props.source==="search"){
            children.push(<Option key={"All"} value={""}>{commonLan.all.label}</Option>);
        }
        for (let i = 0; i < optionList.length; i++) {
            children.push(<Option key={optionList[i].name+i} value={optionList[i].value}>{optionList[i].name}</Option>);
        }
        this.setState({optionsData:children});
    }

    render() {
        let styleBg = false
        this.props.rules?this.props.rules.forEach(item=>{
            if(item.required){
                styleBg = item.required
            }
        }):""
        return (
            <div className={styleBg?"selectBg":""}>
                <Select
                    labelInValue={this.props.labelInValue}
                    style={{...this.props.style,background:styleBg?"#ffffe6":""}}
                    allowClear = {this.props.allowClear}
                    showSearch={this.props.showSearch===false?this.props.showSearch:true}
                    onChange={this.props.onChange}
                    value={this.props.value}
                    disabled={this.props.disabled}
                    optionFilterProp="children"
                    placeholder={commonLan.pleaseSelect.label}
                    defaultValue={this.props.defaultValue}
                    virtual={this.state.optionsData.length>1000}
                >
                    {this.state.optionsData}
                </Select>
            </div>
        
        );
    }
}

export default CommonDictSelect;